import { createFileRoute } from "@tanstack/react-router";
import { BOMTree } from "@/components/companion/BOMTree";

export const Route = createFileRoute("/bom/compare/$bomId")({
  component: BomCompareRoute,
});

function BomCompareRoute() {
  const { bomId } = Route.useParams();
  return <BOMTree bomId={bomId} initialCompare />;
}
